/* global $ */

export function sharedDataTableSettings(options) {
    return {
        paging: options.paging ?? true,
        lengthMenu: options.lengthMenu ?? [25, 50, 75, 100],
        pageLength: options.pageLength ?? 25,
        width: options.width ?? '100%',
        dom: options.dom ?? 'Btr<\'row dt-footer-row\'<\'col-xs-12 col-sm-4 col-md-4 dt-footer-col\'i><\'col-xs-12 col-sm-8 col-md-8 dt-footer-col dataTables_pager\'lp>>',
        language: {
            sProcessing: 'Even geduld a.u.b.',
            sLengthMenu: '_MENU_ resultaten weergeven',
            sZeroRecords: 'Geen resultaten gevonden',
            sInfo: '_START_ tot _END_ van _TOTAL_ resultaten',
            sInfoEmpty: 'Geen resultaten om weer te geven',
            sInfoFiltered: ' (gefilterd uit _MAX_ resultaten)',
            sInfoPostFix: '',
            sSearch: 'Zoeken:',
            sEmptyTable: 'Geen resultaten aanwezig in de tabel',
            sInfoThousands: '.',
            sLoadingRecords: 'Even geduld a.u.b.',
            oPaginate: {
                sFirst: '<<',
                sLast: '>>',
                sNext: '>',
                sPrevious: '<'
            },
            oAria: {
                sSortAscending: ': activeer om kolom oplopend te sorteren',
                sSortDescending: ': activeer om kolom aflopend te sorteren'
            },
            select: {
                rows: {
                    _: '%d rijen geselecteerd',
                    0: '',
                    1: '1 rij geselecteerd'
                }
            }
        },
        pagingType: options.pagingType ?? 'full_numbers',
        processing: options.processing ?? true,
        order: options.order ?? [],
        buttons: options.buttons ?? []
    }
}

export const resetDatatableFilters = function (settings) {
    return new Promise((resolve) => {
        let api = new $.fn.dataTable.Api(settings)

        if (api.init().stateSave === false) {
            resolve()
        }

        let state = api.state.loaded()

        $.each(state?.filtered, function () {
            if (!this.value || !this.id) {
                return true
            }

            let filterElement = $(`#${this.id}`)

            filterElement.val(this.value)
            filterElement.trigger('change')
        })

        api.state.save()

        resolve()
    })
}

export const getCapitalizedEntity = function (entity) {
    return entity.charAt(0).toUpperCase() + entity.slice(1)
}

export const setDatatableReady = function (table) {
    table.attr('ready', '1')
}

export const isDatatableReady = function (table) {
    return table.attr('ready') === '1'
}

export const prepareAjaxData = function (e, table, filters, data) {
    let api = table.DataTable()
    let stateSaveEnabled = api.init().stateSave

    // get current filter state
    let state = api.state.loaded() ?? {}

    // check if this is the first request.
    // If so, load filters from saved state
    if (stateSaveEnabled && !isDatatableReady(table) && state.filtered) {
        $.each(filters, function () {
            let filterName = $(this).attr('name')

            e[filterName] = state.filtered?.find((item) => {
                return item.name === filterName
            })?.value
        })

        if (data) {
            $.each(data, function (key, value) {
                e[key] = value
            })
        }
    } else {
        $.each(filters, function () {
            let filterName = $(this).attr('name')
            e[filterName] = $(this).val()
        })

        if (data) {
            $.each(data, function (key, value) {
                e[key] = value
            })
        }
    }
}

export const hasActiveFilters = function (tableId) {
    let wrapper = $(`#${tableId}`).closest('.dataTables_wrapper_extended')
    let filters = wrapper.find('.dataTable_filter')

    let filtered = false

    filters = filters.filter(function () {
        return $(this).data('allow-reorder') !== true
    })

    $.each(filters, function () {
        filtered = $(this).val()?.length > 0

        if (filtered === true) {
            return false
        }
    })

    return filtered
}

export const toggleDatatableReorder = function (tableId, forceValue = null) {
    if (forceValue === true) {
        window[tableId].rowReorder?.enable()
    } else if (forceValue === false) {
        window[tableId].rowReorder?.disable()
    } else {
        hasActiveFilters(tableId) ?
            window[tableId].rowReorder?.disable() :
            window[tableId].rowReorder?.enable()
    }
}
